import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { Outlet, useLocation, useNavigate } from '@tanstack/react-location';
import PageContainer from '../../core/components/PageContainer';
import { usePropertyId } from '../../core/hooks/usePropertyId';
import PropertySelectionDialog from '../../property/components/PropertySelectionDialog';

const TABS = [
    { label: 'Combined Yearly Heatmap', path: 'heatmap' },
    { label: 'Monthly Heatmaps', path: 'monthly' },
    { label: 'Statistics', path: 'statistics' },
] as const;

const StatsLayout = () => {
    const propertyId = usePropertyId();
    const navigate = useNavigate();
    const location = useLocation();
    const pathname = location.current.pathname;

    const isLegacyRoute = pathname === '/stats' || pathname.startsWith('/stats/');
    const isPropertyRoute = /^\/\d+\/stats/.test(pathname);

    if (!propertyId) {
        if (isPropertyRoute) {
            return null;
        }
        if (isLegacyRoute) {
            return <PropertySelectionDialog open={true} targetPath="/stats" />;
        }
        return null;
    }

    const currentTab = TABS.findIndex(tab =>
        pathname.endsWith(`/stats/${tab.path}`)
    );
    const tabValue = currentTab >= 0 ? currentTab : 0;

    const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
        const tab = TABS[newValue];
        navigate({ to: `/${propertyId}/stats/${tab.path}` });
    };

    return (
        <PageContainer>
            <h1>Statistics</h1>
            <Tabs
                value={tabValue}
                onChange={handleTabChange}
                sx={{ borderBottom: 1, borderColor: 'divider' }}
            >
                {TABS.map(tab => (
                    <Tab key={tab.path} label={tab.label} />
                ))}
            </Tabs>
            <Box>
                <Outlet />
            </Box>
        </PageContainer>
    );
};

export default StatsLayout;
